export function createMainScreenButtons(button, display) {
    return {button, display};
}